module.exports = "img/3.1ef0f2.webp";